module.exports = __webpack_public_path__ + "static/media/zoom-out.e70b9b9d.svg";